import { render, staticRenderFns } from "./ReopenCaseModal.vue?vue&type=template&id=15af2455&"
import script from "./ReopenCaseModal.vue?vue&type=script&lang=ts&"
export * from "./ReopenCaseModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports